import React from 'react';
import {
  EmployeeSelfServiceLayout,
  MaterialRequestLayout,
} from '@Features/index';
import { FullWidthLayout } from '@Features/ContactPage';
import DashboardPage from '@Pages/DashboardPage/DashboardPage';

import { useLocation } from 'react-router-dom';

interface PageLayoutResolverProps {
  children: JSX.Element;
}

const PageLayoutResolver: React.FC<PageLayoutResolverProps> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const isHomeDashboard = pathname === '/';
  const isEmployeeSelfService = pathname.includes('/ess/');
  const isMaterialRequest = pathname.includes('/mr/');
  const isContacts = pathname.includes('/contacts');

  if (isHomeDashboard) {
    return <DashboardPage>{children}</DashboardPage>;
  }

  if (isContacts) {
    return (
      <FullWidthLayout>
        {React.cloneElement(children, { appsText: 'Contacts' })}
      </FullWidthLayout>
    );
  }

  if (isEmployeeSelfService) {
    return (
      <EmployeeSelfServiceLayout>
        {React.cloneElement(children, { appsText: 'ESS' })}
      </EmployeeSelfServiceLayout>
    );
  }

  if (isMaterialRequest) {
    return (
      <MaterialRequestLayout>
        {React.cloneElement(children, { appsText: 'MR' })}
      </MaterialRequestLayout>
    );
  }

  return (
    <EmployeeSelfServiceLayout>
      {React.cloneElement(children, { appsText: 'ESS' })}
    </EmployeeSelfServiceLayout>
  );
};

export default PageLayoutResolver;
